import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { OnlineshopProductImages } from '../../Interface/OnlineshopProductImages';
import { IProduct } from '../Router/Complaints/ComplaintsForm/ProductList/ProductList';

export type SelectedFlavorProps = {
  id: IProduct['id'];
  flavorImages: OnlineshopProductImages | undefined;
};

export const selectedFlavorFamily = atomFamily((data) =>
  atom<SelectedFlavorProps>({
    id: 0,
    flavorImages: undefined,
  })
);

export type ProductsViewT = 'grid' | 'list' | '';

const defaultView: ProductsViewT = '';

export const productViewAtom = atom<ProductsViewT>(defaultView);

export const productsResultCount = atom<number | undefined>(undefined);

export interface ActiveFilterOption {
  name: string;
  value: string | number;
}
